module.exports = __webpack_public_path__ + "static/media/5.8fc35b28.jpg";